<div class="alert-window" *ngIf="!isHidden">
  <div *ngIf="type === 'alert'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="alert-window-content-button" (click)="close()">
      <cowing-button [label]="'Aceptar'"></cowing-button>
    </div>
  </div>
  <div *ngIf="type === 'alertAddEmployee'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="alert-window-content-button" (click)="close()">
      <cowing-button [label]="'Aceptar'" (click)="reloadWindow()"></cowing-button>
    </div>
  </div>
  <div *ngIf="type === 'pause'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="button-group">
      <div class="alert-window-content-button" (click)="close()">
        <cowing-button [label]="'Cancelar'"></cowing-button>
      </div>
      <div class="alert-window-content-button" (click)="pauseSpace()">
        <cowing-button [label]="'Aceptar'"></cowing-button>
      </div>
    </div>
  </div>
  <div *ngIf="type === 'reactivate'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="button-group">
      <div class="alert-window-content-button" (click)="close()">
        <cowing-button [label]="'Cancelar'"></cowing-button>
      </div>
      <div class="alert-window-content-button" (click)="activateSpace()">
        <cowing-button [label]="'Aceptar'"></cowing-button>
      </div>
    </div>
  </div>

  <div *ngIf="type === 'confirmBooking'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="button-group">
      <div class="alert-window-content-button" (click)="cancelBooking()">
        <cowing-button
          [label]="'coworking-home.bookings.cancel' | translate"
        ></cowing-button>
      </div>
      <div class="alert-window-content-button" (click)="confirmBooking()">
        <cowing-button
          [label]="'coworking-home.bookings.accept' | translate"
        ></cowing-button>
      </div>
    </div>
    <div class="alert-window-content-button" (click)="close()">
      <cowing-button
        [label]="'coworking-home.bookings.back' | translate"
      ></cowing-button>
    </div>
  </div>

  <div *ngIf="type === 'cancelBooking'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="button-group">
      <div class="alert-window-content-button" (click)="close()">
        <cowing-button
          [label]="'coworking-home.bookings.back' | translate"
        ></cowing-button>
      </div>
      <div class="alert-window-content-button" (click)="cancelBooking()">
        <cowing-button
          [label]="'coworking-home.bookings.cancel_from_cancel' | translate"
        ></cowing-button>
      </div>
    </div>
  </div>

  <div *ngIf="type === 'deleteCompany'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="button-group">
      <div class="alert-window-content-button" (click)="close()">
        <cowing-button [label]="'Cancelar'"></cowing-button>
      </div>
      <div class="alert-window-content-button" (click)="deleteCompany()">
        <cowing-button [label]="'Aceptar'"></cowing-button>
      </div>
    </div>
  </div>

  <div
    *ngIf="type === 'editCompany'"
    class="alert-window-content edit-company-container"
  >
    <div (click)="close()" class="header">
      <span> <img [src]="getCloseSvg" alt="delete" /> </span>
    </div>
    <div class="content">
      <cowing-core-backoffice-edit-company
        [companyId]="editCompanyId"
        [closeModal]="close.bind(this)"
      >
      </cowing-core-backoffice-edit-company>
    </div>
  </div>

  <div
    *ngIf="type === 'editCoworking'"
    class="alert-window-content edit-company-container"
  >
    <div (click)="close()" class="header">
      <span> <img [src]="getCloseSvg" alt="delete" /> </span>
    </div>
    <div class="content">
      <cowing-core-backoffice-edit-coworking
        [coworkingId]="editCoworkingId"
        [closeModal]="close.bind(this)"
      >
      </cowing-core-backoffice-edit-coworking>
    </div>
  </div>

  <div *ngIf="type === 'deleteEmployee'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="button-group">
      <div class="alert-window-content-button" (click)="close()">
        <cowing-button [label]="'Cancelar'"></cowing-button>
      </div>
      <div class="alert-window-content-button" (click)="deleteEmployee()">
        <cowing-button [label]="'Aceptar'"></cowing-button>
      </div>
    </div>
  </div>

  <div
    *ngIf="type === 'editSpace'"
    class="alert-window-content edit-space-container"
  >
    <div (click)="close()" class="header">
      <span> <img [src]="getCloseSvg" alt="delete" /> </span>
    </div>
    <div class="content">
      <cowing-core-backoffice-edit-space
        [spaceId]="editSpaceId"
        [closeModal]="close.bind(this)"
      >
      </cowing-core-backoffice-edit-space>
    </div>
  </div>

  <div *ngIf="type === 'error'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="alert-window-content-button" (click)="close()">
      <cowing-button [label]="'Aceptar'" (click)="goToLogin()"></cowing-button>
    </div>
  </div>

  <div *ngIf="type === 'errorLocation'" class="alert-window-content">
    <div class="alert-window-content-title">
      {{ title | translate }}
    </div>
    <div class="alert-window-content-subtitle">
      {{ message | translate }}
    </div>

    <div class="button-group-vertical">
      <div class="alert-window-content-button" (click)="onOk()">
        <cowing-button [label]="optionOkText"></cowing-button>
      </div>
      <div class="alert-window-content-button" (click)="close()">
        <cowing-button [type]="EButtonType.SecondaryFill" [label]="optionCancelText"></cowing-button>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" *ngIf="!isHidden"></div>
